export default Vue => {
  Vue.component("v-date", () => import("./v-date.vue"));
};
